import { HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface ImageWithBgProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  alt?: string;
  src: string;
}

export default function ImageWithBg (props: ImageWithBgProps) {
  const { className, src, alt, ...rest } = props

  return (
    <div className={cn(styles.root, className)} {...rest}>
      <img src={src} alt={alt} fetchPriority="low" loading="lazy" />
    </div>
  )
}
